import React from 'react';

import styles from './AccountFinderDisclaimer.css';

const AccountFinderDisclaimer = () => (
    <div className="transfer-sectional">
        <p className="sectional-contents">
            Be sure to review any 529 college savings plan offered by your home
            state or your beneficiary&apos;s home state, as there may be state
            tax or other state benefits, such as financial aid, scholarship
            funds, and protection from creditors that are only available for
            investments in the home state&apos;s plan. Be sure to read the
            college savings plan&apos;s disclosure document, which includes
            investment objectives, risks, fees, charges and expenses, and other
            information you should read and consider carefully before investing.
            Tax benefits may be conditioned on meeting certain requirements,
            such as residency, purpose for or timing of distributions, or other
            factors as applicable.
        </p>
        <style jsx>{styles}</style>
    </div>
);

export default AccountFinderDisclaimer;
